import { render, staticRenderFns } from "./filtersWrap.vue?vue&type=template&id=1870aa9a&scoped=true"
import script from "./filtersWrap.vue?vue&type=script&lang=js"
export * from "./filtersWrap.vue?vue&type=script&lang=js"
import style0 from "./filtersWrap.vue?vue&type=style&index=0&id=1870aa9a&prod&scoped=true&lang=scss"
import style1 from "./filtersWrap.vue?vue&type=style&index=1&id=1870aa9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870aa9a",
  null
  
)

export default component.exports